const vnd = new Intl.NumberFormat('vi-VN');

export const formatMoney = (n: number | undefined): string => n === undefined ? '—' : `${vnd.format(n)}đ`;
export const formatKm = (km: number | undefined): string => km === undefined ? '—' : `${km.toLocaleString('vi-VN', { maximumFractionDigits: 1 })} km`;

const two = (n: number) => String(n).padStart(2, '0');

export function formatDate(iso: string): string {
  const d = new Date(iso);
  return `${two(d.getDate())}/${two(d.getMonth() + 1)}/${d.getFullYear()}`;
}
export function formatTime(iso: string): string {
  const d = new Date(iso);
  const h = d.getHours();
  return `${two(h % 12 === 0 ? 12 : h % 12)}:${two(d.getMinutes())} ${h < 12 ? 'SA' : 'CH'}`;
}
export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return `${two(d.getHours())}:${two(d.getMinutes())}, ${formatDate(iso)}`;
}

/** Số giây còn lại tới mốc hết hạn (≥ 0). */
export const secondsUntil = (iso: string, now = Date.now()): number => Math.max(0, Math.ceil((new Date(iso).getTime() - now) / 1000));

export const shortCode = (id: string, n = 8): string => `…${id.slice(-n)}`;
